import React, { useEffect } from 'react'
import Modal from 'react-modal'
import LoadingSpin from 'react-loading-spin'

const SpinnerDefault = (props) => {
  useEffect(() => Modal.setAppElement('body'), [])
  return (
    <Modal
      style={{
        content: {
          background: 'transparent !important',
          alignContent: 'center',
          top: '40%',
          left: '50%',
          marginTop: '-20px',
          marginLeft: '-50px',
          width: '500px',
          border: '0px',
        },
      }}
      isOpen={props.showSpin}
      centered
    >
      <div style={{ align: 'center', alignContent: 'center' }}>
        <LoadingSpin
          primaryColor="#fff"
          secondaryColor="#053dbf"
          style={{ align: 'center' }}
          centered
        />
      </div>
    </Modal>
  )
}

export default React.memo(SpinnerDefault)
